// replaces [[image-left]] and [[image-right]] placeholders in article content
// format: [[image-left]] Title || Description text
//         followed by <br><br><img ...>
// the img directly after the placeholder (skipping <br> nodes) becomes the image

const IMAGE_TEXT_RE = /^\[\[image-(left|right)\]\]\s*/;

function initializeImageTextReplace() {
  const content = document.querySelector('.article-template__content');
  if (!content) return;

  // collect all text nodes that match [[image-left/right]]
  const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
  const matches = [];

  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (IMAGE_TEXT_RE.test(node.nodeValue)) {
      matches.push(node);
    }
  }

  // process in reverse so DOM mutations don't affect earlier nodes
  for (let i = matches.length - 1; i >= 0; i--) {
    processPlaceholder(matches[i], content);
  }
}

function processPlaceholder(textNode, contentEl) {
  const raw = textNode.nodeValue;
  const dirMatch = raw.match(/^\[\[image-(left|right)\]\]\s*/);
  if (!dirMatch) return;

  const direction = dirMatch[1]; // 'left' or 'right'
  const rest = raw.slice(dirMatch[0].length).trim();

  // parse "Title || Description" — description is optional
  const sepIdx = rest.indexOf('||');
  const title = sepIdx >= 0 ? rest.slice(0, sepIdx).trim() : rest.trim();
  const description = sepIdx >= 0 ? rest.slice(sepIdx + 2).trim() : '';

  // find the nearest <img> — first scan forward siblings within the same parent,
  // then look in the next sibling element of the parent (cross-paragraph)
  const parent = textNode.parentNode;
  let img = null;
  let imgParent = parent;
  let node = textNode.nextSibling;

  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
      img = node;
      break;
    }
    if (node.nodeType === Node.ELEMENT_NODE &&
        ['P', 'H1', 'H2', 'H3', 'H4', 'DIV', 'FIGURE'].includes(node.tagName)) {
      break;
    }
    node = node.nextSibling;
  }

  // if not found inline, check the previous sibling paragraph for an <img>
  // (handles case where image was placed before the placeholder paragraph)
  if (!img) {
    const prevEl = parent.previousElementSibling;
    if (prevEl) {
      const prevImg = prevEl.querySelector('img');
      if (prevImg) {
        img = prevImg;
        imgParent = prevEl;
      }
    }
  }

  // also check next sibling element
  if (!img) {
    const nextEl = parent.nextElementSibling;
    if (nextEl) {
      const nextImg = nextEl.querySelector('img');
      if (nextImg) {
        img = nextImg;
        imgParent = nextEl;
      }
    }
  }

  if (!img) return;

  // build the image-text widget
  const widget = document.createElement('div');
  widget.className = 'article-image-text article-image-text--' + direction;

  const imgWrapper = document.createElement('div');
  imgWrapper.className = 'article-image-text__image';
  const imgClone = img.cloneNode(true);
  imgWrapper.appendChild(imgClone);

  const textWrapper = document.createElement('div');
  textWrapper.className = 'article-image-text__body';

  if (title) {
    const h3 = document.createElement('h3');
    h3.className = 'article-image-text__title';
    const spaceIdx = title.indexOf(' ');
    if (spaceIdx > 0) {
      const firstWord = title.slice(0, spaceIdx);
      const rest = title.slice(spaceIdx); // includes leading space
      const accent = document.createElement('span');
      accent.className = 'article-image-text__title-accent';
      if (direction === 'left') {
        accent.textContent = firstWord;
        h3.appendChild(accent);
        h3.appendChild(document.createTextNode(rest));
      } else {
        h3.appendChild(document.createTextNode(firstWord));
        accent.textContent = rest; // includes leading space
        h3.appendChild(accent);
      }
    } else {
      h3.textContent = title;
    }
    textWrapper.appendChild(h3);
  }

  if (description) {
    const p = document.createElement('p');
    p.className = 'article-image-text__description';
    p.textContent = description;
    textWrapper.appendChild(p);
  }

  if (direction === 'left') {
    widget.appendChild(imgWrapper);
    widget.appendChild(textWrapper);
  } else {
    widget.appendChild(textWrapper);
    widget.appendChild(imgWrapper);
  }

  // insert widget before the placeholder text node in parent
  parent.insertBefore(widget, textNode);

  if (imgParent === parent) {
    // img is inline: remove nodes from textNode up to and including img
    const toRemove = [];
    let cur = textNode;
    while (cur) {
      toRemove.push(cur);
      if (cur === img) break;
      cur = cur.nextSibling;
    }
    toRemove.forEach(n => n.parentNode && n.parentNode.removeChild(n));
  } else {
    // img is in a separate sibling element: remove the text node and the whole img container
    textNode.parentNode && textNode.parentNode.removeChild(textNode);
    // remove the img element or its containing paragraph if it's the only content
    if (imgParent.children.length === 1 && imgParent.children[0] === img) {
      imgParent.remove();
    } else {
      img.remove();
    }
  }

  // hoist out of word-paste wrappers until direct child of content
  while (widget.parentElement && widget.parentElement !== contentEl) {
    const wrapper = widget.parentElement;
    const grandParent = wrapper.parentNode;
    if (!grandParent) break;

    const afterSibling = wrapper.nextSibling;

    // collect nodes after widget inside wrapper → move to new clone
    const remainder = [];
    let sib = widget.nextSibling;
    while (sib) { remainder.push(sib); sib = sib.nextSibling; }

    grandParent.insertBefore(widget, afterSibling);

    if (remainder.length > 0) {
      const clone = wrapper.cloneNode(false);
      remainder.forEach(n => clone.appendChild(n));
      grandParent.insertBefore(clone, widget.nextSibling);
    }

    if (!wrapper.textContent.trim() && !wrapper.children.length) {
      wrapper.remove();
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeImageTextReplace);
} else {
  initializeImageTextReplace();
}
